import React, { useMemo, useState } from "react";
import { Button, Modal, Table } from "antd";
import { formatNumber, toDisplayFormat } from "../../../../lib/utils";
import { useAppSelector } from "../../../..";
import { ReactComponent as DeleteBinIcon } from "../../../../img/delete.svg";
import { TableCustomProps } from "../../../../lib/interfaces/TableRecord";
import "./AdjustmentsModal.less";

interface ComponentProps {
  visible: boolean;
  isLoading: boolean;
  closeModal: () => void;
  openCreateAdjusmentModal: () => void;
  submitDeleteAdjusment: (transactionId: number) => Promise<void>;
}

type TableProps = TableCustomProps<{
  transactionId: number;
  adjustmentTypeId: number;
  transactionDate: string;
  amount: string;
  adjustmentTypeName: string;
  dsc: string;
}>;

export const AdjustmentsModal = (props: ComponentProps) => {
  const { visible, closeModal, openCreateAdjusmentModal, submitDeleteAdjusment, isLoading } = props;

  const [deletedTransactionId, setDeletedTransactionId] = useState<number>();
  const closeDeleteAdjusmentModal = () => {
    setDeletedTransactionId(undefined);
  };
  const { dicAdjustmentType } = useAppSelector((state) => state.rtkDictionaries);
  const { payment, paymentAdjustments } = useAppSelector((state) => state.accountPaymentDetails);

  const adjusmentsColumns: TableProps["columns"] = [
    {
      title: "Дата",
      key: "transactionDate",
      dataIndex: "transactionDate",
    },
    {
      title: "Сумма",
      key: "amount",
      dataIndex: "amount",
    },
    {
      title: "Тип корректировки",
      key: "adjustmentTypeName",
      dataIndex: "adjustmentTypeName",
    },
    {
      title: "Комментарий",
      dataIndex: "dsc",
      key: "dsc",
    },
    {
      key: "btns",
      render: (_, { transactionId, adjustmentTypeId }) => {
        return (
          adjustmentTypeId !== 4 && (
            <DeleteBinIcon
              onClick={() => setDeletedTransactionId(transactionId)}
              className="adjustments-modal__binBtn"
            />
          )
        );
      },
    },
  ];

  const tableData = useMemo<TableProps["dataSource"]>(() => {
    return paymentAdjustments
      ?.filter(({ parentTransactionId }) => parentTransactionId === payment?.transactionId)
      .map(({ transactionId, balanceTransaction, adjustmentTypeId, dsc }) => {
        return {
          key: transactionId,
          transactionId,
          adjustmentTypeId,
          transactionDate: toDisplayFormat(balanceTransaction.transactionDate),
          amount: formatNumber(balanceTransaction.amount * -1),
          adjustmentTypeName:
            dicAdjustmentType.find(({ id }) => id === adjustmentTypeId)?.name || "",
          dsc,
        };
      });
  }, [paymentAdjustments, payment, dicAdjustmentType]);

  return (
    <>
      <Modal
        className="adjustments-modal"
        visible={visible}
        title={
          <>
            <div style={{ marginBottom: "15px" }}>Корректировки платежа</div>
            <Button
              type="primary"
              onClick={openCreateAdjusmentModal}
              style={Number(payment?.extra?.availableAmount) > 0 ? {} : { visibility: "hidden" }}
            >
              Создать корректировку
            </Button>
          </>
        }
        onCancel={closeModal}
        footer={null}
      >
        <Table size="small" columns={adjusmentsColumns} dataSource={tableData} pagination={false} />
      </Modal>
      <Modal
        className="delete-adjustments-modal"
        visible={!!deletedTransactionId}
        title="Корректировка будет удалена. Вы подтверждаете действие?"
        onCancel={closeDeleteAdjusmentModal}
        footer={
          <>
            <Button onClick={closeDeleteAdjusmentModal}>Отмена</Button>
            <Button
              type="primary"
              onClick={() => {
                submitDeleteAdjusment(deletedTransactionId!).then(closeDeleteAdjusmentModal);
              }}
              loading={isLoading}
            >
              Далее
            </Button>
          </>
        }
      />
    </>
  );
};
